// extracted by mini-css-extract-plugin
export default {"listItem":"memberListItem_listItem__XD967","assigned":"memberListItem_assigned__UAyfE","closed":"memberListItem_closed__RulrR"};